export function tween(start: number, end: number, percent: number) {
  return start + (end - start) * percent
}
